<template>
  <el-dialog
    :title="
      profileId
        ? $t('config.profile.title.updateTravellerForm')
        : $t('config.profile.title.createTravellerForm')
    "
    :visible="visible"
    width="70%"
    append-to-body
    :close-on-click-modal="false"
    @close="$emit('cancel')"
  >
    <CustomerForm
      ref="CustomerForm"
      :show-search-field="false"
      :record-data="customer"
      @selectDuplicateCustomer="onSelectDuplicateCustomer"
      @onSelectCustomer="onSelectCustomer"
      @onClearForm="onClearCustomerForm"
    ></CustomerForm>
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; gap: 10px; justify-content: flex-end"
    >
      <button
        v-if="customerFormAction == 'edit'"
        class="btn primary small"
        @click="onUpdateCustomer"
      >
        Cập nhật
      </button>
      <button
        v-if="customerFormAction == 'create'"
        class="btn primary small"
        @click="onCreateCustomer"
      >
        Tạo
      </button>
      <button class="btn primary small outline" @click="onCloseDialog">
        Hủy
      </button>
    </span>
  </el-dialog>
</template>

<script>
import CustomerForm from '@/components/resources/customer/CustomerForm.vue'
import { CellRenderCheckbox } from '@/utils/cellRenders'
import { notifyError, notifySuccess } from '@/utils/toast'

import {
  addTravellerApi,
  getTravellerByIdApi,
  updateTravellerApi
} from '@/api/configuration/profile/traveller'
export default {
  components: {
    CustomerForm,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckbox
  },
  props: {
    profileId: null,
    visible: {
      default: false
    }
  },
  data() {
    return {
      selectedCustomer: null,
      customer: null
    }
  },
  computed: {
    customerFormAction() {
      if (this.selectedCustomer == null) {
        return 'create'
      }
      return 'edit'
    }
  },
  watch: {
    visible: {
      async handler(value) {
        this.selectedCustomer = null
        if (value && this.profileId) {
          await this.onBookingTravelerSelected([
            { traveller_id: this.profileId }
          ])
        } else {
          this.$nextTick(() => {
            this.$refs.CustomerForm.hydrateForm()
          })
        }
      }
    }
  },
  async mounted() {
    if (this.visible && this.profileId) {
      await this.onBookingTravelerSelected([{ traveller_id: this.profileId }])
    } else {
      this.$nextTick(() => {
        this.$refs.CustomerForm.hydrateForm()
      })
    }
  },
  methods: {
    onCloseDialog() {
      this.$emit('cancel')
    },
    async onFindDuplicateCustomer(phone, number) {
      await this.findDuplicateTraveller(phone, number)
    },
    onRemoveCustomerFromBooking() {
      this.$emit('removeCustomerFromBooking', this.selectedCustomer.id)
    },
    async onBookingTravelerSelected(travelers) {
      const customer = await this.getCustomer(travelers[0].traveller_id)
      if (customer == null) {
        this.$message({
          type: 'error',
          message: 'Đã có lỗi xảy ra khi tìm thông tin khách hàng'
        })
      } else {
        this.selectedCustomer = customer
        this.hydrateCustomerForm(customer)
      }
    },
    hydrateCustomerForm(customer = null) {
      // console.debug('customer', customer)
      this.$refs.CustomerForm.hydrateForm(customer)
    },
    async onSelectDuplicateCustomer(duplicate) {
      const customer = await this.getCustomer(duplicate.id)
      if (customer == null) {
        this.$message({
          type: 'error',
          message: 'Đã có lỗi xảy ra khi tìm thông tin khách hàng'
        })
      } else {
        this.selectedCustomer = customer
        this.hydrateCustomerForm(customer)
      }
    },
    onSelectCustomer(customer) {
      this.selectedCustomer = customer
    },
    onClearCustomerForm() {
      this.selectedCustomer = null
      this.hydrateCustomerForm()
    },
    async onCreateCustomer() {
      const error = this.$refs.CustomerForm.validateForm()
      if (error != null) {
        notifyError(error, true)
        return
      }
      const payload = this.$refs.CustomerForm.dehydrateForm()
      const formData = new FormData()
      if (payload.uploaded_document_front_file !== null) {
        formData.append('frontImage', payload.uploaded_document_front_file)
        delete payload.uploaded_document_front_file
      }

      if (payload.uploaded_document_back_file !== null) {
        formData.append('backImage', payload.uploaded_document_back_file)
        delete payload.uploaded_document_back_file
      }
      formData.append('travellerInsertRequest', JSON.stringify(payload))
      const traveller = await this.createCustomer(formData)
      if (traveller) {
        this.visible = false
        // this.selectedCustomer = traveller
        // this.hydrateCustomerForm(traveller)
      }
    },
    async createCustomer(payload) {
      const customer = await addTravellerApi(payload)
        .then(res => {
          notifySuccess(res?.message)
          return res?.data
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
          return null
        })

      return customer
    },
    async onUpdateCustomer() {
      const error = this.$refs.CustomerForm.validateForm()
      if (error != null) {
        notifyError(error, true)
        return
      }
      const payload = this.$refs.CustomerForm.dehydrateForm()
      const formData = new FormData()
      if (payload.uploaded_document_front_file !== null) {
        formData.append('frontImage', payload.uploaded_document_front_file)
        delete payload.uploaded_document_front_file
      }

      if (payload.uploaded_document_back_file !== null) {
        formData.append('backImage', payload.uploaded_document_back_file)
        delete payload.uploaded_document_back_file
      }
      formData.append('travellerUpdateRequest', JSON.stringify(payload))
      const isSuccess = await this.updateCustomer(
        formData,
        this.selectedCustomer.id
      )
      if (isSuccess) {
        this.visible = false
        // this.hydrateCustomerForm()
        this.selectedCustomer = null
        this.customerFormAction = 'create'
      }
      // this.selectedCustomer = traveller
    },
    async updateCustomer(payload, id) {
      return await updateTravellerApi(payload, id)
        .then(res => {
          const message = res?.data?.message
          notifySuccess(message)
          return true
        })
        .catch(err => {
          const message = err?.response?.data?.message
          notifyError(message)
          return false
        })
    },
    async getCustomer(id) {
      const customer = await getTravellerByIdApi({ id })
        .then(res => {
          const customer = res.data
          if (customer.birth) {
            customer.birth = this.$moment(customer.birth).format('YYYY-MM-DD')
          }
          return customer
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
          return null
        })

      return customer
    }
  }
}
</script>
